import type * as Types from '../../../../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type FontPackByNameForTemplateQueryVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;

export type FontPackByNameForTemplateQuery = {
  __typename?: 'Query';
  fontPackByName?: {
    __typename?: 'FontPack';
    id: string;
    configuration?: Array<{
      __typename?: 'FontPackConfiguration';
      id: string;
      category: Types.Category;
      size?: number | null;
      sizePercent?: number | null;
      font?: { __typename?: 'Font'; id: string; fontFamily: string; fontSize: number; fontWeight: number; firebaseFontKey: string } | null;
    }> | null;
  } | null;
};

export const FontPackByNameForTemplateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FontPackByNameForTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fontPackByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'configuration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'font' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fontWeight' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firebaseFontKey' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sizePercent' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFontPackByNameForTemplateQuery__
 *
 * To run a query within a React component, call `useFontPackByNameForTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFontPackByNameForTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFontPackByNameForTemplateQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFontPackByNameForTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FontPackByNameForTemplateQuery, FontPackByNameForTemplateQueryVariables>) {
  return ApolloReactHooks.useQuery<FontPackByNameForTemplateQuery, FontPackByNameForTemplateQueryVariables>(FontPackByNameForTemplateDocument, baseOptions);
}
export function useFontPackByNameForTemplateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FontPackByNameForTemplateQuery, FontPackByNameForTemplateQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<FontPackByNameForTemplateQuery, FontPackByNameForTemplateQueryVariables>(FontPackByNameForTemplateDocument, baseOptions);
}
export type FontPackByNameForTemplateQueryHookResult = ReturnType<typeof useFontPackByNameForTemplateQuery>;
export type FontPackByNameForTemplateLazyQueryHookResult = ReturnType<typeof useFontPackByNameForTemplateLazyQuery>;
export type FontPackByNameForTemplateQueryResult = Apollo.QueryResult<FontPackByNameForTemplateQuery, FontPackByNameForTemplateQueryVariables>;
